module.exports = __webpack_public_path__ + "img/UTCORA-7.6d8b77f9.jpg";